module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.II"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.II"
    }
  }, [_vm._v("II. Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("One may analyze the structure of any book in several ways. The kind of structure one sees depends on the questions one asks. Most commentators have structured Numbers in three sections related to geographic locale: section I at Mt. Sinai ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:10")]), _vm._v("); section II at and around Kadesh-barnea ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–19:22")]), _vm._v("), and section III on the plains of Moab ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:1–36:13")]), _vm._v("). This kind of structure involves two travel sections: the first from Sinai to Kadesh-barnea ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–12:13")]), _vm._v("), and the second from Kadesh-barnea to the plains of Moab ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:1–21:35")]), _vm._v("). The venue of section I is the same as that for "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 20")]), _vm._v("–"), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 27")]), _vm._v(" and hence links Numbers with the central books in the Pentateuch.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.2.0002",
      "id": "FN.2.0002r"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', [_vm._v("D. T. Olson has proposed an alternate structure that divides the book into two sections of unequal length: section I: The Death of the Old Generation; the first Exodus generation fails in the wilderness ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–25:19")]), _vm._v("); and section II: The Birth of the New; the second Exodus generation prepares to take the land of Canaan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:1–36:13")]), _vm._v("). This view sees the two census documents (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(") as forming the pillars of the book’s structure, and the theme of the book as two-generational: the failure of one generation and the promise of another.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.2.0003",
      "id": "FN.2.0003r"
    }
  }, [_vm._v("2")]), _vm._v("﻿ Section I is broken down into a cycle of preparation for departure and inauguration of it ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:36")]), _vm._v("), "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.3"
    }
  }), _vm._v("and a cycle of rebellion, death, and deliverance, ending in ultimate failure ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11:1–25:19")]), _vm._v("). Section II is broken down into a large and disparate group of passages dealing with preparation and organization of the second Exodus generation as it prepares to enter the land of Canaan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:1–36:13")]), _vm._v("). The fate of that second generation is left open at the end of the book, and is a matter of conjecture—perhaps a promise of great success, perhaps a warning of great danger.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.3.0004",
      "id": "FN.3.0004r"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', [_vm._v("Although Olson’s analysis has much to recommend it, the more traditional analysis of Numbers connects the book more closely with the Pentateuch, in which it is, after all, set. With most commentators on the book, I follow such an analysis here.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-233976c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-nicot04nu-0010.vue
// module id = 81
// module chunks = 0